import React, { useEffect, useState } from "react";
import styles from "./BaseLayout.module.css";

import Notification from "../../../components/UI/notification/Notification";
import { Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Dialog } from "primereact/dialog";
import { getTokenInfo, logOut } from "../../../utils/Guard";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { authActions } from "../../../store/auth-store/auth-slice";
import { UpdateUser } from "../../../store/auth-store/auth-actions";


const BaseLayout = () => {
  const userInfo = getTokenInfo();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth.auth);
  const notification = useSelector((state) => state.ui.notification);
  const [showModal, setShowModal] = useState(false);
  const [invalidField, setInvalidField] = useState("");
  const [filledInputs, setFilledInputs] = useState({
    name: false,
    lastName: false,
    email: false,
    password: false,
  });
  const [focused, setFocused] = useState({
    name: false,
    lastName: false,
    email: false,
    password: false,
  });
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (userInfo !== undefined && userInfo !== null && userInfo.id !== null && userInfo.id !== undefined && (userInfo.name === "" || userInfo.last_name === "")) {
      setShowModal(true);
    }
  }, [userInfo]);

  useEffect(() => {
    if (token !== null && typeof token === "string") {
      const isTokenValid = getTokenInfo(token);

      if (
        isTokenValid === null &&
        location.pathname !== "/login" &&
        location.pathname !== "/register" &&
        location.pathname !== "/forgot-password" &&
        location.pathname !== "/reset-password"
      ) {
        logOut();
        window.location.href = "/login";
      }
    }
  }, [token]);

  const handleBlur = (field) => {
    setFocused((prev) => ({ ...prev, [field]: false }));
    setFilledInputs((prev) => ({ ...prev, [field]: prev[field] }));
  };

  const handleFocus = (field) => {
    setFocused((prev) => ({ ...prev, [field]: true }));
  };

  const onChangeHandler = (id, value) => {
    setInvalidField("");
    setFilledInputs((prev) => ({ ...prev, [id]: value.length > 0 }));
    dispatch(authActions.modifyPropertyValue({ id, value }));

    if (value !== "") {
      dispatch(authActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(authActions.setFieldValid({ id, value: false }));
    }
  };
  const isValid = true;

  const onSubmitHandler = () => {
    dispatch(UpdateUser(auth, userInfo.id));
  };

  return (
    <>
      <div>
        
          <>
            {/* <NavBar /> */}
            <Outlet></Outlet>
            {notification && (
              <Notification
                status={notification.status}
                title={notification.title}
                message={notification.message}

              />
            )}
          </>

      </div>
      <Dialog header="Importante" visible={showModal} style={{ width: 'auto' }} closable={false}>
        <div className="flex flex-column gap-4">
          <p>Por motivos de seguridad es necesario actualizar tus datos</p>
          <FloatLabel>
            <InputText
              id="name"
              placeholder=" "
              name="name"
              type="text"
              label="Nombre"
              value={auth.name}
              onBlur={() => handleBlur("name")}
              onFocus={() => handleFocus("name")}
              onChange={(e) => onChangeHandler("name", e.target.value)}
              className={`${styles.InputFields} ${invalidField === "name" ? "p-invalid" : ""}`}
              invalid={invalidField === "name"}
            />
            <label htmlFor="name" className={styles.InputFields}>Nombre</label>
          </FloatLabel >

          {invalidField === "name" && (
            <small id="name-help" className={`${styles.inputWarningText}`}>El campo nombre no puede estar vacío</small>
          )}
          <FloatLabel className={filledInputs.lastName || focused.lastName ? "mt-4" : "mt-0"}>
            <InputText
              id="lastName"
              name="lastName"
              type="text"
              label="Apellido"
              value={auth.lastName !== undefined ? auth.lastName : ""}
              onFocus={() => handleFocus("lastName")}
              onBlur={() => handleBlur("lastName")}
              onChange={(e) => onChangeHandler("lastName", e.target.value)}
              className={styles.InputFields}
              invalid={invalidField === "lastName"}
            />
            <label className={styles.InputFields}>Apellido</label>
          </FloatLabel>
          {invalidField === "lastName" && (
            <small id="lastName-help" className={`${styles.inputWarningText}`}>El campo apellido no puede estar vacío</small>
          )}
          <Button onClick={() => onSubmitHandler()} label="Enviar" type="submit" className={`${styles.formButton} p-button-primary mt-1`} />
        </div>
      </Dialog>
    </>
  );
};
export default BaseLayout;
